"use client";

import Link from "next/link";
import { ArrowRight, Wrench } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const TOOLS = [
  "Filesystem", "Terminal", "Git", "Tests", "Browser", "Search", "MCP", "Subagents",
];

export default function ToolTeaser() {
  return (
    <section className="py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-6">
        <ScrollReveal>
          <div className="cta-mesh rounded-3xl p-10 lg:p-14 text-center" style={{ border: "1px solid var(--border)" }}>
            <div
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider mb-5"
              style={{
                background: "rgba(108,92,231,0.04)",
                color: "var(--mc-violet)",
                border: "1px solid rgba(108,92,231,0.1)",
              }}
            >
              <Wrench className="w-3.5 h-3.5" />
              50+ tools
            </div>
            <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-black tracking-tight mb-3 leading-[1.1]">
              Agents that can actually{" "}
              <span className="hero-gradient-text">reach your system.</span>
            </h2>
            <p className="text-[15px] text-(--text-secondary) max-w-2xl mx-auto leading-relaxed mb-6">
              Filesystem, terminal, git, test runner, browser, search, subagents and MCP servers.
              50+ implemented tools, every one behind an explicit permission you control.
            </p>
            <p className="text-[14px] text-(--text-secondary) max-w-xl mx-auto leading-relaxed mb-8">
              An agent that can only suggest is a chatbot. An agent that can edit, run, test and verify
              is a colleague.
            </p>
            <div className="flex flex-wrap justify-center gap-2 mb-8">
              {TOOLS.map((tool) => (
                <span
                  key={tool}
                  className="inline-flex items-center justify-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider"
                  style={{
                    background: "rgba(108,92,231,0.06)",
                    color: "var(--mc-violet)",
                    border: "1px solid rgba(108,92,231,0.1)",
                  }}
                >
                  {tool}
                </span>
              ))}
            </div>
            <Link href="/features" className="btn btn-ghost">
              See all 50+ tools <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
